import React from "react";
import push2 from "../../assets/images/push2.png";
import push from "../../assets/images/push.png";
import { Link } from "react-router-dom";

function Hero() {
  return (
    <section className="text-gray-600 body-font">
      <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
            Receiving Mpesa Payments Online has never been this easy
            {/* <br className="hidden lg:inline-block" /> */}
          </h1>
          <p className="mb-8 leading-relaxed">
            Have you ever wondered how you can receive mpesa payments online?
            <br /> Worry No More
            <br />
            <br />
            <span className="text-yellow-700 font-bold uppercase">
              Lipia Pay{" "}
            </span>
            gives you the platform to seamlessly collect payments on your
            website via our{" "}
            <span className="text-yellow-700 font-bold uppercase">
              developer API
            </span>{" "}
            ,Or get paid instantly to your bank account, till or paybill using
            our payment links. Quick and Easy.
          </p>
          <div className="flex justify-center">
            <Link to="/login">
              <button className="inline-flex text-white bg-yellow-700 border-0 py-2 px-6 focus:outline-none hover:bg-yellow-600 rounded text-lg">
                Try It Out
              </button>
            </Link>
          </div>
        </div>
        <div className="hidden md:block lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <div>
            <div className="md:p-2 p-1 w-full">
              <img
                alt="gallery"
                className="w-full object-contain object-center block h-80"
                src={push}
              />
            </div>
            <div className="md:p-2 p-1 w-full flex ">
              <div className="md:p-2 p-1 w-1/2">
                <img
                  alt="gallery"
                  className="w-full object-contain h-32 object-center block"
                  src={push2}
                />
              </div>
              <div className="md:p-2 p-1 w-1/2 ">
                <img
                  alt="gallery"
                  className="w-full object-contain h-32 object-center block"
                  src={push2}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
